var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data.visible
    ? _c("div", { staticClass: "pb-vue-gallery-component-container" }, [
        _c(
          "div",
          {
            staticClass: "modal fade modalGallery show",
            attrs: {
              id: "modalGallery" + _vm.galleryNumber,
              tabindex: "-1",
              role: "dialog",
              "aria-labelledby": "referenceGallery"
            }
          },
          [
            _c(
              "div",
              { staticClass: "modal-dialog", attrs: { role: "document" } },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _c("div", { staticClass: "modal-header" }, [
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: {
                          type: "button",
                          "data-dismiss": "modal",
                          "aria-label": "Close"
                        },
                        on: {
                          click: function($event) {
                            return _vm.closeModal()
                          }
                        }
                      },
                      [_c("span", { staticClass: "mdi mdi-close" })]
                    )
                  ]),
                  _c(
                    "div",
                    {
                      class:
                        "modal-body" +
                        (_vm.isThumbnailDots
                          ? " with-thumbnail-navigation "
                          : "")
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "project-modal-gallery modal-gallery-slick-slider",
                          attrs: { id: "gallery" + _vm.galleryNumber }
                        },
                        [
                          _c(
                            "div",
                            {
                              class:
                                "modal-gallery-slick-slider-list draggable " +
                                (_vm.isThumbnailDots
                                  ? " dots-with-thumbnail "
                                  : "")
                            },
                            _vm._l(_vm.images, function(image, index) {
                              return _c(
                                "div",
                                {
                                  key: "modal_image_" + index,
                                  staticClass: "modal-gallery-item"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "modal-gallery-image-container"
                                    },
                                    [
                                      typeof image.caption != "undefined" &&
                                      image.caption != "" &&
                                      image.caption != null
                                        ? _c("img", {
                                            attrs: {
                                              "data-lazy": image.webImage,
                                              alt: image.caption,
                                              "data-counter":
                                                index +
                                                1 +
                                                "/" +
                                                _vm.images.length
                                            }
                                          })
                                        : _c("img", {
                                            attrs: {
                                              "data-lazy": image.webImage,
                                              alt: "",
                                              "data-counter":
                                                index +
                                                1 +
                                                "/" +
                                                _vm.images.length
                                            }
                                          }),
                                      _vm.isMobile
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "image-caption-container mobilecounter"
                                            },
                                            [
                                              false
                                                ? [
                                                    _vm._v(
                                                      _vm._s(index + 1) +
                                                        "/" +
                                                        _vm._s(
                                                          _vm.images.length
                                                        )
                                                    )
                                                  ]
                                                : [
                                                    image.caption
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "image-caption"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                image.caption
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    image.copyright
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "image-copyright"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                "© " +
                                                                  image.copyright
                                                              )
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    image.url &&
                                                    image.link_label
                                                      ? _c(
                                                          "a",
                                                          {
                                                            attrs: {
                                                              href: image.url,
                                                              target:
                                                                image.link_target
                                                            }
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                image.link_label
                                                              ) + " "
                                                            ),
                                                            _c("i", {
                                                              staticClass:
                                                                "fa fa-external-link"
                                                            })
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  ),
                                  !_vm.isMobile
                                    ? _c(
                                        "p",
                                        {
                                          staticClass: "image-caption-container"
                                        },
                                        [
                                          false
                                            ? [
                                                _vm._v(
                                                  _vm._s(index + 1) +
                                                    "/" +
                                                    _vm._s(_vm.images.length)
                                                )
                                              ]
                                            : [
                                                image.caption
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "image-caption"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(image.caption)
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                image.copyright
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "image-copyright"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            "© " +
                                                              image.copyright
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                image.url && image.link_label
                                                  ? _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: image.url,
                                                          target:
                                                            image.link_target
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            image.link_label
                                                          ) + " "
                                                        ),
                                                        _c("i", {
                                                          staticClass:
                                                            "fa fa-external-link"
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                        ],
                                        2
                                      )
                                    : _vm._e()
                                ]
                              )
                            }),
                            0
                          )
                        ]
                      )
                    ]
                  )
                ])
              ]
            )
          ]
        ),
        _c("div", {
          staticClass: "modal-backdrop fade show modalGallery-modal-backdrop"
        })
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }